import React from "react";
import { PromotersList } from "../components/PromotersList";

const PromotersPage = () => {
  return <PromotersList />;
};

export default PromotersPage;
